import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { notificationsApi } from '../../modules/notifications/api/notificationsApi';

const Topbar = ({ onMenuToggle }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const currentUser = (() => {
    try { return JSON.parse(localStorage.getItem('current_user') || 'null'); }
    catch (e) { return null; }
  })();
  const userName = currentUser && (currentUser.name || currentUser.Name || '');
  const userEcode = currentUser && (currentUser.ecode || currentUser.ECode || '');

  const sortedNotifications = useMemo(() => {
    return [...notifications].sort((a, b) => {
      const aTime = new Date(a.created_at || a.CreatedAt || 0).getTime();
      const bTime = new Date(b.created_at || b.CreatedAt || 0).getTime();
      return bTime - aTime;
    });
  }, [notifications]);

  const refreshCount = async () => {
    try {
      const data = await notificationsApi.getUnreadCount();
      setUnreadCount(data?.count || 0);
    } catch (error) {
      console.error('Failed to fetch notification count:', error);
    }
  };

  const refreshNotifications = async () => {
    setIsLoading(true);
    try {
      const data = await notificationsApi.getUnread();
      setNotifications(data);
    } catch (error) {
      console.error('Failed to fetch notifications:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    refreshCount();
    const interval = setInterval(refreshCount, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isOpen) {
      refreshNotifications();
    }
  }, [isOpen]);

  const handleNotificationClick = async (notification) => {
    const id = notification?.id || notification?.ID;
    const relatedDealId = notification?.related_deal_id || notification?.RelatedDealID;
    const relatedEnquiryId = notification?.related_enquiry_id || notification?.RelatedEnquiryID;

    if (id) {
      try {
        await notificationsApi.markRead(id);
        setNotifications((prev) => prev.filter((n) => (n.id || n.ID) !== id));
        refreshCount();
      } catch (error) {
        console.error('Failed to mark notification as read:', error);
      }
    }

    setIsOpen(false);
    if (relatedDealId) {
      navigate(`/sales-pipeline?dealId=${relatedDealId}`);
      return;
    }
    if (relatedEnquiryId) {
      navigate(`/enquiries?enquiryId=${relatedEnquiryId}`);
    }
  };

  return (
    <div className="topbar">
      <div className="topbar-content">
        <button type="button" onClick={onMenuToggle} className="md:hidden p-2 mr-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-colors flex-shrink-0" aria-label="Open menu">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" /></svg>
        </button>
        <div className="flex-1" />
        <div className="topbar-actions">
          <button
            type="button"
            onClick={() => setIsOpen((prev) => !prev)}
            className="relative rounded-full p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors"
            aria-label="Notifications"
          >
            <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V4a2 2 0 10-4 0v1.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0a3 3 0 11-6 0h6z" />
            </svg>
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-red-600 px-1 text-xs font-semibold text-white">
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
          </button>
          {isOpen && (
            <div className="notifications-dropdown">
              <div className="notifications-header">
                <span className="text-sm font-semibold text-gray-900">Notifications</span>
                <button
                  type="button"
                  onClick={refreshNotifications}
                  className="text-xs text-blue-600 hover:text-blue-800"
                >
                  Refresh
                </button>
              </div>
              <div className="notifications-body">
                {isLoading && (
                  <div className="px-4 py-3 text-sm text-gray-500">Loading...</div>
                )}
                {!isLoading && sortedNotifications.length === 0 && (
                  <div className="px-4 py-6 text-sm text-gray-500">No new notifications.</div>
                )}
                {!isLoading && sortedNotifications.map((notification) => (
                  <button
                    key={notification.id || notification.ID}
                    type="button"
                    onClick={() => handleNotificationClick(notification)}
                    className="notification-item"
                  >
                    <span className="text-sm text-gray-900">{notification.message || notification.Message}</span>
                    <span className="text-xs text-gray-500 mt-1">
                      {notification.created_at || notification.CreatedAt
                        ? new Date(notification.created_at || notification.CreatedAt).toLocaleString('en-IN')
                        : ''}
                    </span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;
